import { Action } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';
import { FeatureFlag } from 'features/feature-set/types';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { closeActionNotifications } from 'features/notifications/thunks/closeActionNotifications';
import { NotificationId } from 'features/notifications/types';

export function* closeTranscriptionNotificationSaga() {
  const notificationIds: NotificationId[] = yield select(
    selectNotificationsByScope,
    FeatureFlag.captions
  );

  const closeNotificationsThunk: Action = yield call(closeActionNotifications, notificationIds);

  yield put(closeNotificationsThunk);
}
